export type GetVehicleCustomerApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      vehicleId?: string | null;
      dateFrom?: string | null;
      eventType?: string | null;
      eventId?: string | null;
      customerId?: string | null;
      customerType?:
        | (
            | 'CORVEHICLECUSTOMERTYPE_OPERATOR'
            | 'CORVEHICLECUSTOMERTYPE_OWNER'
            | 'CORVEHICLECUSTOMERTYPE_USER'
            | 'CORVEHICLECUSTOMERTYPE_MANAGER'
            | 'CORVEHICLECUSTOMERTYPE_INVOICE'
          )
        | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetVehicleCustomerApiArg = {
  /** UUID */
  vehicleId?: string | null;
  /** UUID */
  customerId?: string | null;
};
export type PostVehicleCustomerApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostVehicleCustomerApiArg = {
  body: {
    id?: string | null;
    vehicleId?: string | null;
    dateFrom?: string | null;
    eventType?: 'service-case' | 'vehicle' | null;
    eventId?: string | null;
    customerId?: string | null;
    customerType?:
      | (
          | 'CORVEHICLECUSTOMERTYPE_OPERATOR'
          | 'CORVEHICLECUSTOMERTYPE_OWNER'
          | 'CORVEHICLECUSTOMERTYPE_USER'
          | 'CORVEHICLECUSTOMERTYPE_MANAGER'
          | 'CORVEHICLECUSTOMERTYPE_INVOICE'
        )
      | null;
  } | null;
};
export type DeleteVehicleCustomerApiResponse =
  | /** status 200 Standard response */ ({
      error?: {
        message?: string | null;
        data?: {
          [key: string]: any;
        } | null;
      } | null;
      errors?: ({
        message?: string | null;
        code?: string | null;
      } | null)[];
      validationErrors?: ({
        message?: string | null;
        field?: string | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type DeleteVehicleCustomerApiArg = {
  /** UUID */
  vehicleId: string;
  customerType:
    | (
        | 'CORVEHICLECUSTOMERTYPE_OPERATOR'
        | 'CORVEHICLECUSTOMERTYPE_OWNER'
        | 'CORVEHICLECUSTOMERTYPE_USER'
        | 'CORVEHICLECUSTOMERTYPE_MANAGER'
        | 'CORVEHICLECUSTOMERTYPE_INVOICE'
      )
    | null;
};

export type SmartSearchVehicleApiResponse = ({
  id: string;
  customerId: string;
  customerTypes?: ({
    key?:
      | (
          | 'CORVEHICLECUSTOMERTYPE_OPERATOR'
          | 'CORVEHICLECUSTOMERTYPE_OWNER'
          | 'CORVEHICLECUSTOMERTYPE_USER'
          | 'CORVEHICLECUSTOMERTYPE_MANAGER'
          | 'CORVEHICLECUSTOMERTYPE_INVOICE'
        )
      | null;
    label?: string | null;
  } | null)[];
  vehicleRegistrationPlate?: string | null;
  vehicleVin?: string | null;
  vehicleTitle?: string | null;
} | null)[];

export type SmartSearchVehicleApiArg = {
  body: {
    filters?: {
      customerId: string;
      smartSearch?: string | null;
    } | null;
    limit: number;
    offset: number;
    order?: ({
      columnKey?: ('vehicleId' | 'vehicleRegistrationPlate' | 'vehicleVin' | 'vehicleTitle') | null;
      order?: ('ASC' | 'DESC') | null;
    } | null)[];
  } | null;
};
